export default `<p><strong>Versione documento:</strong> V3.28 &nbsp;|&nbsp; <strong>Data di pubblicazione:</strong> 2022 &nbsp;|&nbsp; <strong>Tipo:</strong> Whitepaper prodotto e riepilogo valutazione sicurezza</p>

<h2>1. Sommario esecutivo</h2>
<p>Questo modulo Lending Pool è un servizio di prestito e liquidità on-chain basato su protocolli DeFi di mercato monetario. Tramite smart contract open source e modelli di tasso programmabili, il sistema collega gli asset digitali degli utenti ai mercati di prestito on-chain consolidati, abilitando <strong>rendimenti su depositi, prestiti garantiti e liquidità condivisa</strong>.</p>
<p>Il modulo non richiede intervento manuale per l'allocazione quotidiana dei fondi. Tassi, capacità e utilizzo sono determinati in tempo reale dai mercati on-chain e mostrati in modo trasparente tramite aggregazione dati multi-fonte.</p>

<h2>2. Contesto di settore e posizionamento</h2>
<p>Il credito tradizionale dipende da istituzioni centralizzate. I protocolli DeFi utilizzano smart contract per abbinare automaticamente domanda e offerta, con sovracollateralizzazione e meccanismi di liquidazione.</p>
<p>Posizionamento di questo modulo:</p>
<ul>
  <li><strong>Gateway ai mercati monetari on-chain:</strong> aggrega dati di pool su più chain e protocolli;</li>
  <li><strong>Distribuzione programmatica dei rendimenti:</strong> regolamento automatico su base fissa in base ai saldi autorizzati e all'APY di mercato;</li>
  <li><strong>Trasparente e verificabile:</strong> TVL, APY, utilizzo e LTV tracciabili su dati on-chain pubblici;</li>
  <li><strong>Non custodial:</strong> autorizzazione e interazioni on-chain avviate dal wallet dell'utente.</li>
</ul>

<h2>3. Architettura di sistema</h2>
<h3>3.1 Panoramica</h3>
<ul>
  <li><strong>Interfaccia utente:</strong> connessione wallet, autorizzazione, navigazione pool, consultazione guadagni;</li>
  <li><strong>Layer di servizio:</strong> autenticazione, gestione autorizzazioni, ordini di rendimento, contenuti multilingua;</li>
  <li><strong>Layer di aggregazione dati:</strong> sincronizzazione programmata da fonti DeFi pubbliche;</li>
  <li><strong>Layer protocollo on-chain:</strong> smart contract di prestito auditati eseguono depositi e prestiti.</li>
</ul>

<h3>3.2 Metriche chiave</h3>
<table>
  <thead>
    <tr><th>Metrica</th><th>Descrizione</th></tr>
  </thead>
  <tbody>
    <tr><td>TVL</td><td>Asset totali del pool in USD</td></tr>
    <tr><td>Supply APY</td><td>Rendimento annuo depositi (tasso base + ricompense)</td></tr>
    <tr><td>Borrow APY</td><td>Costo annuo pagato dai mutuatari</td></tr>
    <tr><td>Tasso di utilizzo</td><td>Rapporto fondi presi in prestito su fondi disponibili</td></tr>
    <tr><td>Max LTV</td><td>Rapporto prestito/valore massimo prima della liquidazione</td></tr>
    <tr><td>Supply / Borrow Cap</td><td>Limiti per asset per controllare il rischio di concentrazione</td></tr>
    <tr><td>Liquidità disponibile</td><td>Liquidità immediatamente prelevabile</td></tr>
  </tbody>
</table>

<h2>4. Flusso utente e meccanismo di rendimento</h2>
<ol>
  <li><strong>Connetti il wallet</strong> via Web3;</li>
  <li><strong>Autorizza gli asset</strong> (USDT, USDC, ecc.) con Approve on-chain;</li>
  <li><strong>Entra nel lending pool</strong> per la coda di calcolo dei rendimenti;</li>
  <li><strong>Regolamento rendimenti</strong> giornaliero in base al saldo autorizzato e ai tassi di mercato;</li>
  <li><strong>Consulta gli asset</strong> in «Il mio portafoglio».</li>
</ol>
<p><strong>L'APY storico non garantisce rendimenti futuri.</strong></p>

<h3>4.3 Commissioni</h3>
<h4>Come vengono addebitate le commissioni DeFi Earn?</h4>
<p>Le transazioni on-chain richiedono commissioni gas per interagire con gli smart contract, inclusi sottoscrizione e riscossione dei rendimenti. Per alcuni asset, il lending pool DeFi e i gestori del vault possono addebitare una commissione di performance come percentuale del profitto effettivo; il capitale non è interessato.</p>

<h2>5. Progettazione della sicurezza</h2>
<ul>
  <li>Protocolli sottostanti con contratti open source auditati;</li>
  <li>Architettura non custodial; nessuna chiave privata memorizzata;</li>
  <li>Permessi Token Approve minimi; revocabili in qualsiasi momento;</li>
  <li>Auth token, HTTPS, RBAC admin e audit trail operativi.</li>
</ul>

<h2>6. Riepilogo valutazione sicurezza</h2>
<table>
  <thead>
    <tr><th>Voce</th><th>Esito</th><th>Note</th></tr>
  </thead>
  <tbody>
    <tr><td>Dipendenze smart contract</td><td><strong>Superato</strong></td><td>Protocolli DeFi auditati pubblicamente</td></tr>
    <tr><td>Non custodial e gestione chiavi</td><td><strong>Superato</strong></td><td>Nessun storage di chiavi private</td></tr>
    <tr><td>API e autenticazione</td><td><strong>Superato</strong></td><td>Auth token e HTTPS attivi</td></tr>
    <tr><td>Sincronizzazione dati</td><td><strong>Superato</strong></td><td>Sync programmata con snapshot</td></tr>
    <tr><td>Logica regolamento rendimenti</td><td><strong>Superato</strong></td><td>Regole esplicite; ordini verificabili</td></tr>
  </tbody>
</table>

<h2>7. Informativa sui rischi</h2>
<ul>
  <li><strong>Rischio smart contract:</strong> possibili vulnerabilità non scoperte;</li>
  <li><strong>Rischio di mercato:</strong> l'APY può variare significativamente;</li>
  <li><strong>Rischio di liquidazione:</strong> calo del collaterale può attivare la liquidazione;</li>
  <li><strong>Rischio de-peg stablecoin:</strong> USDT/USDC possono deviare da $1,00;</li>
  <li><strong>Rischio normativo:</strong> la regolamentazione DeFi è in evoluzione.</li>
</ul>
<p><strong>Questo modulo non fornisce consulenza d'investimento e non garantisce rendimenti fissi.</strong></p>

<h2>8. Glossario</h2>
<ul>
  <li><strong>APY:</strong> rendimento percentuale annuo;</li>
  <li><strong>TVL:</strong> valore totale bloccato;</li>
  <li><strong>LTV:</strong> rapporto prestito/valore;</li>
  <li><strong>Approve:</strong> autorizzazione token ERC-20;</li>
  <li><strong>Liquidazione:</strong> vendita automatica del collaterale in caso di sottocollateralizzazione.</li>
</ul>

<p>— Solo a scopo informativo. Non costituisce consulenza legale, finanziaria o d'investimento. Verificare i dati on-chain tramite block explorer e interfacce ufficiali dei protocolli.</p>`
